import * as React from "react";

// style, design
import { FormAreaDescription, FormAreaTitle } from "../Base/Chapters/styles";

// store, state
import { constants, useApartmentForm } from "../../../store/apartments";
import {
  create,
  destroyPatchForm,
  destroyPostForm,
  update,
  detailUrl,
} from "../../../store/apartments";

import StandardModal from "../../Modals/StandardModal";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { updateActiveFormInstance } from "../../../store/base";
import OverlaySpinner from "../../Loaders/OverlaySpinner";
import ManyMediaField from "../Base/Fields/ManyMediaField";
import { cloneDeep } from "lodash";

export default ({ method, open, setOpen, instance }) => {
  const [loading, setLoading] = React.useState(false);
  const dispatch = useDispatch();
  const { push } = useHistory();

  const storeName = constants.STORE_NAME;

  const formLoaded = Boolean(useApartmentForm(method, instance.id));

  const preProcess = (data) => {
    const clone = cloneDeep(data);

    return { images: clone.images };
  };

  React.useEffect(() => {
    if (formLoaded && instance) {
      dispatch(
        updateActiveFormInstance({
          storeName: constants.STORE_NAME,
          data: { ...instance },
        })
      );
    }
  }, [formLoaded, open]);

  const checkout = (success) => {
    if (method === "POST") {
      dispatch(destroyPostForm(success));
    } else if (method === "PATCH") {
      dispatch(destroyPatchForm(success));
    }
    setOpen(false);
  };

  const onSuccess = (_, returned) => {
    setLoading(false);
    checkout(true);
    if (method === "POST") {
      push(detailUrl({ id: returned.id }));
    }
  };

  const onFailure = (_, returned) => {
    setLoading(false);
  };

  const onSubmit = async () => {
    setLoading(true);
    if (method === "POST") {
      dispatch(
        create({
          successCallback: onSuccess,
          errorCallback: onFailure,
          preProcess: preProcess,
        })
      );
    } else if (method === "PATCH") {
      let id = instance.id;
      dispatch(
        update({
          id,
          successCallback: onSuccess,
          errorCallback: onFailure,
          preProcess: preProcess,
        })
      );
    }
  };

  return (
    <>
      <StandardModal
        isOpen={open}
        closeFunction={() => setOpen(false)}
        title={"Bildhantering"}
        withActionBar
        saveFunction={onSubmit}
      >
        {(!formLoaded || loading) && <OverlaySpinner />}
        {formLoaded ? (
          <>
            <FormAreaTitle>Bilder</FormAreaTitle>
            <FormAreaDescription>
              Redigera och ladda upp bilder
            </FormAreaDescription>

            <ManyMediaField
              storeName={storeName}
              method={method}
              fieldKey="images"
              fileKey="image"
              allowedFormats={[".jpg", ".jpeg", ".png"]}
            />
          </>
        ) : (
          "Loading"
        )}
      </StandardModal>
    </>
  );
};
